// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"37570493","342":"78960484","448":"fefe42f7"}[chunkId] + ".chunk.css";
};